import buildUrl from 'build-url';
import React from 'react';
import css from './ReportsV2EmptyState.module.scss';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import {faTwitch} from '@fortawesome/free-brands-svg-icons';
import {buildRoute} from '../../navigation/navigationUtils';
import {DASHBOARD_ROUTES} from '../../navigation/dashboard/DashboardRoutes';

export type ReportsV2EmptyStateProps = {
  type: 'connect-twitch' | 'start-streaming';
};

export const ReportsV2EmptyState = (props: ReportsV2EmptyStateProps) => {
  const isConnectTwitchType = props.type === 'connect-twitch';
  const ctaText = isConnectTwitchType
    ? 'Connect Twitch'
    : 'Learn how to stream';

  const title = isConnectTwitchType
    ? 'Connect your Twitch account to track heart rate dynamics'
    : 'Start streaming with Pulsoid to get heart rate stats';

  const onConnectTwitchClick = () => {
    const url = buildUrl('https://pulsoid.net', {
      path: '/oauth/twitch/initiate',
      queryParams: {
        redirect: buildUrl('https://pulsoid.net', {
          path: '/ui/profile/settings',
        }),
      },
    });

    window.open(url, '_blank');
  };

  return (
    <div className={css.root}>
      <div className={css.header}>
        <h4 className={css.titlePlaceholder}>Heart rate dynamics</h4>

        <div className={css.legendPlaceholder}>
          <div className={css.lgFirst}>
            <div className={css.legendPlaceholderIndicator} />
            Spike BPM
          </div>
          <div className={css.lgSecond}>
            <div className={css.legendPlaceholderIndicator} />
            BPM
          </div>
        </div>
      </div>

      <div className={css.contentWrapper}>
        <div className={css.contentBg} />
        <div className={css.content}>
          <h4 className={css.title}>{title}</h4>

          <ButtonV2
            className={css.cta}
            type={isConnectTwitchType ? 'twitch' : 'primary'}
            onClick={isConnectTwitchType ? onConnectTwitchClick : undefined}
            href={
              !isConnectTwitchType
                ? buildRoute({path: DASHBOARD_ROUTES.WELCOME})
                : undefined
            }
            prefixIcon={isConnectTwitchType ? faTwitch : undefined}
          >
            {ctaText}
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};
